module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-b0865ab8c981857ff30b04ef45de3483.png";